import React from 'react';
import ModalModule from '../modal';
import BrandedTracking from './BrandedTracking.component';

const { Modal } = ModalModule;

const BrandedTrackingModal = ({ modalId }) => (
	<Modal
		modalId={modalId}
		header="Branded Settings"
		className="common-branded-tracking-modal"
		hideFooter
	>
		<div className="body">
			<BrandedTracking />
		</div>
	</Modal>
);

export default BrandedTrackingModal;
